import {
  FilterOutlined,
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Input,
  Menu,
  Popconfirm,
  Row,
  Select,
  Tooltip,
} from "antd";
import { FC, useEffect, useState } from "react";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
import dayjs from "dayjs";
import { getApi, getApiCSV, getApiExcel } from "redux/apis";
import "./index.scss";
import Export from "components/Global/Export";
import { toastText } from "utils/utils";
import moment from "moment";
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  const {
    performSearchHandler,
    searchValue,
    // searchFields,
    // isServiceCenter,
    onApply,
    handleServiceCenterChange,
    selectedServiceCenter,
    handleSparePartsChange,
    selectedSpareParts,
    handleFromDateChange,
    handleToDateChange,
    fromDate,
    toDate,
    handleSalesOrderNumberChange,
    selectedSalesOrderNumbers,
    handleStatusChange,
    selectedStatus,
    setFiltersReset,
    handleDeleteClick,
    selectedRowKeys,
    canDelete = false,
  } = props;

  const [selectedKey, setSelectedKey] = useState("itemNumber");
  const [serviceCenters, setServiceCenters] = useState([]);
  const [spareParts, setSpareParts] = useState([]);
  const [salesOrderNumberOptions, setSalesOrderNumberOptions] = useState([]);

  const items = [
    // {
    //   key: "serviceCenter",
    //   label: "Service Center",
    // },
    {
      key: "itemNumber",
      label: "Item Name",
    },
    {
      key: "deliveryDate",
      label: "Delivery Date",
    },
    {
      key: "salesOrderNumber",
      label: "Sales Order",
    },
    {
      key: "status",
      label: "Status",
    },
  ];

  const handleMenuClick = (e: any) => {
    setSelectedKey(e.key);
  };

  const handleCancel = () => {
    setSelectedKey("itemNumber");
    handleServiceCenterChange([]);
    handleSparePartsChange([]);
    handleSalesOrderNumberChange([]);
    handleFromDateChange(null);
    handleToDateChange(null);
    handleStatusChange(null);
    setFiltersReset(true);
  };

  const handleExportExcel = async () => {
    try {
      //  setIsExportLoading(true);
      //   const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
      // const formattedToDate = dayjs(toDate).format("YYYY-MM-DD");

      const query: any = {
        serviceCenterId: selectedServiceCenter,
        itemNumber: selectedSpareParts,
        //   startDate: formattedFromDate, // Convert to date-only format
        //    endDate: formattedToDate, // Convert to date-only format
        salesOrderNumber: selectedSalesOrderNumbers,
        excludeShipped: true,
        status: selectedStatus,
      };

      if (fromDate) {
        query.startDate = dayjs(fromDate).format("YYYY-MM-DD");
      }
      if (toDate) {
        query.endDate = dayjs(toDate).format("YYYY-MM-DD");
      }

      const response: any = await getApiExcel(`/inventory/export`, query);

      const fileName =
        moment(new Date()).format("MM/DD/YYYY_hh-mm-ss") +
        `_Report_product_shipped.xlsx`;

      const excelBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const excelUrl = URL.createObjectURL(excelBlob);
      const link = document.createElement("a");
      link.href = excelUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // toastText(response.data, 'success');
    } catch (err: any) {
      if (err.response.status === 400) {
        toastText("No data found for file export.", "error");
      } else {
        toastText("Something went wrong in exporting excel report.", "error");
      }
    } finally {
      // setIsExportLoading(false);
    }
  };

  const downloadCsv = async () => {
    try {
      //   const formattedFromDate = dayjs(fromDate).format("YYYY-MM-DD");
      //  const formattedToDate = dayjs(toDate).format("YYYY-MM-DD");
      console.log("Asdasdasd");
      const query: any = {
        serviceCenterId: selectedServiceCenter,
        itemNumber: selectedSpareParts,
        //  startDate: formattedFromDate,
        //   endDate: formattedToDate,
        // salesOrderNumber: selectedSalesOrderNumbers,
        excludeShipped: true,
        status: selectedStatus,
      };

      if (fromDate) {
        query.startDate = dayjs(fromDate).format("YYYY-MM-DD");
      }
      if (toDate) {
        query.endDate = dayjs(toDate).format("YYYY-MM-DD");
      }

      const response = await getApiCSV("/inventory/export-csv", query);
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );

      const link = document.createElement("a");
      link.href = url;

      const fileName =
        moment(new Date()).format("MM/DD/YYYY_hh-mm-ss") +
        `_Report_product_shipped.csv`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err: any) {
      if (err.response.status === 400) {
        toastText("No data found for file export", "error");
      } else {
        toastText("Something went wrong in exporting csv report.", "error");
      }
      // toastText("Something went wrong in downloading csv template", "error");
    }
  };

  useEffect(() => {
    const fetchServiceCenters = async () => {
      try {
        const response = await getApi("/serviceCenter/shipment-dropdown");
        if (response.data.success) {
          setServiceCenters(
            response.data.data.map((center: any) => ({
              value: center.id,
              label: center.name,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch service centers:", error);
      }
    };

    const fetchsSpareParts = async () => {
      try {
        const response = await getApi("/shipment/getProducts?type=true");
        if (response.data.data.length > 0) {
          setSpareParts(
            response.data.data.map((center: any) => ({
              value: center.name,
              label: center.name,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch items:", error);
      }
    };

    const fetchSalesOrderNumber = async () => {
      try {
        const response = await getApi("/inventory/sales-order");
        if (response.data.data.length > 0) {
          setSalesOrderNumberOptions(
            response.data.data.map((center: any) => ({
              value: center.salesOrderNumber,
              label: center.salesOrderNumber,
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch items:", error);
      }
    };

    fetchServiceCenters();
    fetchsSpareParts();
    fetchSalesOrderNumber();
  }, []);
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row gutter={[8, 8]} align="middle" justify="space-between">
          <Col>
            <Row gutter={[8, 8]} align="middle">
              <Col>
                <Input
                  className={styles["search-filter__search"]}
                  placeholder="Search..."
                  suffix={<SearchOutlined />}
                  onChange={performSearchHandler}
                  value={searchValue}
                  size="large"
                  // disabled={searchFields.length === 0 || isServiceCenter}
                />
              </Col>
              <Col>
                <Popconfirm
                  placement="rightBottom"
                  title={false}
                  rootClassName="filter-container"
                  description={
                    <div
                      className={styles["filer-content"] + " filter-content"}
                    >
                      <Menu
                        mode="vertical"
                        items={items}
                        onClick={handleMenuClick}
                        selectedKeys={[selectedKey]}
                        defaultSelectedKeys={[selectedKey]}
                      />
                      {/* {selectedKey === "serviceCenter" && (
                        <div>
                          <Select
                            options={serviceCenters}
                            placeholder="Select Service Center"
                            value={selectedServiceCenter ?? null}
                            onChange={handleServiceCenterChange}
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input: string, option?: any) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      )} */}
                      {selectedKey === "itemNumber" && (
                        <div>
                          <Select
                            mode="multiple"
                            options={spareParts}
                            placeholder="Select Item Name"
                            value={selectedSpareParts ?? []}
                            maxTagCount="responsive"
                            maxTagTextLength={15}
                            onChange={(value) => {
                              handleSparePartsChange(value);
                            }}
                            showSearch
                            optionFilterProp="label"
                            filterOption={(input: string, option?: any) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      )}
                      {selectedKey === "deliveryDate" && (
                        <div>
                          <p>From Date</p>
                          <DatePicker
                            size="large"
                            format={{
                              format: "MM/DD/YYYY",
                              type: "mask",
                            }}
                            value={fromDate ? dayjs(fromDate) : null}
                            onChange={(date) => handleFromDateChange(date)}
                            style={{ width: "100%" }}
                            disabledDate={(current) => {
                              const flag =
                                toDate && current && current > dayjs(toDate);
                              return Boolean(flag);
                            }}
                          />
                          {toDate && !fromDate && (
                            <p style={{ color: "red" }}>
                              From Date is required.
                            </p>
                          )}

                          <p style={{ marginTop: "15px" }}>To Date</p>
                          <DatePicker
                            size="large"
                            format={{
                              format: "MM/DD/YYYY",
                              type: "mask",
                            }}
                            style={{ width: "100%" }}
                            value={toDate ? dayjs(toDate) : null}
                            onChange={(date) => handleToDateChange(date)}
                            disabledDate={(current) => {
                              const flag =
                                fromDate &&
                                current &&
                                current < dayjs(fromDate);
                              return Boolean(flag);
                            }}
                          />
                          {/* Validation message */}
                          {fromDate && !toDate && (
                            <p style={{ color: "red" }}>To Date is required.</p>
                          )}
                        </div>
                      )}

                      {selectedKey === "salesOrderNumber" && (
                        <div>
                          <Select
                            mode="multiple"
                            options={salesOrderNumberOptions}
                            placeholder="Select Sales Order"
                            value={selectedSalesOrderNumbers ?? []}
                            onChange={handleSalesOrderNumberChange}
                            showSearch
                            optionFilterProp="label"
                            maxTagCount="responsive"
                            maxTagTextLength={15}
                            filterOption={(input: string, option?: any) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          />
                        </div>
                      )}
                      {selectedKey === "status" && (
                        <div>
                          <Select
                            options={[
                              { value: "RECEIVED", label: "Received" },
                              { value: "DAMAGED", label: "Damaged" },
                              { value: "LOST", label: "Lost" },
                            ]}
                            placeholder="Select Status"
                            value={selectedStatus ?? null}
                            onChange={handleStatusChange}
                          />
                        </div>
                      )}
                    </div>
                  }
                  okText="Apply"
                  cancelText="Cancel"
                  onConfirm={() => onApply && onApply()}
                  onCancel={handleCancel}
                  icon={false}
                  okButtonProps={{
                    disabled: (fromDate && !toDate) || (toDate && !fromDate),
                  }}
                >
                  <Tooltip
                    title="Filters"
                    placement="top"
                    destroyTooltipOnHide={true}
                  >
                    <Button
                      type="primary"
                      className={styles["search-filter__markReceived"]}
                    >
                      <FilterOutlined style={{ fontSize: "20px" }} />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              </Col>
              {selectedRowKeys && selectedRowKeys.length > 0 && canDelete && (
                <Col>
                  <Tooltip
                    title="Delete Selected"
                    placement="top"
                    destroyTooltipOnHide={true}
                  >
                    <Button
                      type="primary"
                      danger
                      className={styles["search-filter__delete"]}
                      onClick={handleDeleteClick}
                    >
                      Delete
                      <DeleteOutlined style={{ fontSize: "20px" }} />
                    </Button>
                  </Tooltip>
                </Col>
              )}
            </Row>
          </Col>
          <Col>
            <Export
              handleExport={(type: string) => {
                if (type === "csv") {
                  downloadCsv();
                  // exportCSv();
                }
                if (type === "xls") {
                  handleExportExcel();
                  // exportExcel();
                }
              }}
              // isLoading={isExportLoading}
              isLoading={false}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
